import { Action as _Action } from '@ngrx/store';
import { UserProfile } from '../models';
import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';

export const LOAD_AD_USER = '[AdUser] LOAD AD USER';
export const LOAD_AD_USER_SUCCESS = '[AdUser] LOAD AD USER Success';
export const LOAD_AD_USER_FAILED = '[AdUser] LOAD AD USER Failure';

export const LOAD_CURRENT_USER_SUCCESS = '[AdUser] LOAD CURRENT USER Success';

export class LoadAdUser implements _Action {
  readonly type = LOAD_AD_USER;
  constructor(public payload: string) {}
}
export class LoadAdUserSuccess implements _Action {
  readonly type = LOAD_AD_USER_SUCCESS;
  constructor(public payload: UserProfile) {}
}
export class LoadAdUserFailed extends errorActions.Fail {
  readonly type = LOAD_AD_USER_FAILED;
}
export class LoadCurrentUserSuccess implements _Action {
  readonly type = LOAD_CURRENT_USER_SUCCESS;
  constructor(public payload: UserProfile) {}
}

export type Action = LoadAdUser | LoadAdUserFailed | LoadAdUserSuccess | LoadCurrentUserSuccess;
